module.exports = __webpack_public_path__ + "img/clock-stopwatch.90e6eff5.svg";